import { BaseEditItemStore } from "@leap4/frontend";
import { IOrganizationAdvertiserLogin } from "../../interfaces/IOrganizationAdvertiserLogin";

export class EditOrganizationStore extends BaseEditItemStore<IOrganizationAdvertiserLogin>{
    entityName: string = "Organization";
}
